/**
 * AI Split Test Engine v2.0
 * Automatically runs A/B tests with full tracking
 */

(function() {
  'use strict';

  const SplitTestEngine = {
    tests: [],
    activeTests: [],

    // Initialize the engine
    init: function() {
      console.log('[Split Test] Engine initialized v2.0');
      this.loadTests();
      this.assignVariations();
      this.trackPageView();
    },

    // Load test configurations
    loadTests: function() {
      this.tests = window.__SPLIT_TESTS__ || [];
      console.log('[Split Test] Loaded ' + this.tests.length + ' tests');
    },

    // Assign user to test variations
    assignVariations: function() {
      const currentPath = window.location.pathname;

      this.tests.forEach((test) => {
        // Check if test applies to current page
        if (this.matchesPage(currentPath, test.page)) {
          const assignment = this.getAssignment(test.id, test.trafficSplit);

          if (assignment === 'variation') {
            this.applyVariation(test);
            this.activeTests.push(test.id);
          }

          console.log('[Split Test]', test.testName, '→', assignment.toUpperCase(), test.trafficSplit === 1 ? '(100% traffic)' : '');
        }
      });
    },

    // Check if current page matches test page
    matchesPage: function(currentPath, testPage) {
      if (testPage === 'all') return true;
      return currentPath === testPage || currentPath.startsWith(testPage);
    },

    // Get user assignment (control or variation)
    getAssignment: function(testId, trafficSplit) {
      const storageKey = 'split_test_' + testId;
      let assignment = localStorage.getItem(storageKey);

      // trafficSplit: 0.5 = 50/50, 1.0 = 100% variation (measure-only mode)
      const split = typeof trafficSplit === 'number' ? trafficSplit : 0.5;

      if (!assignment) {
        assignment = Math.random() < split ? 'variation' : 'control';
        localStorage.setItem(storageKey, assignment);

        // Track assignment
        this.trackEvent(testId, 'user_assigned', assignment);
      }

      return assignment;
    },

    // Apply variation changes to DOM
    applyVariation: function(test) {
      if (!test.code) {
        console.warn('[Split Test] No code for test:', test.testName);
        return;
      }

      // Inject CSS
      if (test.code.css) {
        const style = document.createElement('style');
        style.textContent = test.code.css;
        document.head.appendChild(style);
        console.log('[Split Test] CSS injected for', test.id);
      }

      // External JavaScript files should be loaded in theme.liquid
      // The external script itself must check the split test assignment internally
      // since Liquid templating doesn't work in .js files
      if (test.code.javascript_file) {
        console.log('[Split Test] External JS file registered:', test.code.javascript_file);
        console.log('[Split Test] External scripts must check localStorage assignment');
      }

      // Execute inline JavaScript
      if (test.code.javascript) {
        try {
          eval(test.code.javascript);
          console.log('[Split Test] Inline JS executed for', test.id);
        } catch (e) {
          console.error('[Split Test] Error in variation code:', e);
        }
      }

      // Fire tracking event
      this.trackEvent(test.id, 'variation_shown');
    },

    // Track page view
    trackPageView: function() {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'split_test_page_view',
          active_tests: this.activeTests,
          timestamp: new Date().toISOString()
        });
      }
    },

    // Track event
    trackEvent: function(testId, eventName, value) {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'split_test_event',
          test_id: testId,
          event_name: eventName,
          event_value: value || null,
          timestamp: new Date().toISOString()
        });
      }

      console.log('[Split Test] Event:', eventName, '| Test:', testId, '| Value:', value);
    },

    // Track custom events
    trackCustomEvent: function(eventName, data) {
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'split_test_custom',
          event_name: eventName,
          event_data: data,
          timestamp: new Date().toISOString()
        });
      }
    },

    // Public API for tracking conversions
    trackConversion: function(testId, metricName, value) {
      this.trackEvent(testId, 'conversion_' + metricName, value);
    }
  };

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => SplitTestEngine.init());
  } else {
    SplitTestEngine.init();
  }

  // Expose to window
  window.SplitTestEngine = SplitTestEngine;

  // Track add to cart
  document.addEventListener('submit', function(e) {
    if (e.target && e.target.querySelector('[name="add"]')) {
      SplitTestEngine.trackEvent('product_interaction', 'add_to_cart', 1);
    }
  });

  // Track checkout clicks
  document.addEventListener('click', function(e) {
    const target = e.target;
    if (target && (target.name === 'checkout' || target.closest('[name="checkout"]'))) {
      SplitTestEngine.trackEvent('cart_interaction', 'checkout_click', 1);
    }
  });

})();
